import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NgIf } from '@angular/common';
import { Router, RouterLink, RouterLinkActive, UrlTree } from '@angular/router';

@Component({
  selector: 'app-toolbar-button',
  standalone: true,
  imports: [ButtonModule, TooltipModule, NgIf, RouterLink, RouterLinkActive],
  templateUrl: './toolbar-button.component.html',
  styleUrl: './toolbar-button.component.scss',
})
export class ToolbarButtonComponent {
  @Input() icon = '';
  @Input() backLink = 'data-backend';
  @Input() routerLink: any;
  @Input() label = '';
  @Input() tooltip = '';
  @Input() labelVisibility = false;
  @Input() access = true;

  constructor(private router: Router) {}

  /**
   * Navigates to a specified backLink if the current routerLink is active.
   * The method checks the active status of the current route using exact matching for paths and query parameters,
   * and ignores fragments and matrix parameters. If the route is active, it navigates to the backLink.
   *
   * @return {void} Does not return a value.
   */
  navigateBack(): void {
    if (!this.routerLink) return;
    // Create a UrlTree from the routerLink
    const urlTree: UrlTree = this.router.createUrlTree(this.routerLink);

    // Use isActive with IsActiveMatchOptions to compare the UrlTree
    const isActive = this.router.isActive(urlTree, {
      paths: 'exact',
      queryParams: 'exact',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });

    if (isActive) {
      // If the route is active, navigate to the backLink
      this.router.navigate([this.backLink]);
    }
  }
}
